let currentTimeout = null;
const events = [
  'click',
  'mousedown',
  'mousemove',
  'wheel',
  'keydown',
  'touchstart',
  'scroll'
];

const initiateInactivityTimer = ({
  token,
  signOut,
  eventListenerCallback = null,
  timeouts,
  INACTIVITY_SIGNOUT_TIME
}) => {
  // define eventListenerCallback if it does not yet exist
  if (!eventListenerCallback) {
    eventListenerCallback = () => {
      timeouts.forEach(timeoutNumber => clearTimeout(timeoutNumber));
      timeouts = [];
      currentTimeout = setTimeout(() => {
        signOut();
        window.location.href = window.location.origin; // navigate to homepage
      }, INACTIVITY_SIGNOUT_TIME);
      timeouts.push(currentTimeout);
    };
  }

  // initiate logout countdown upon module activation
  eventListenerCallback();

  // on login, add event listeners for logout countdown
  if (token) {
    events.forEach(event =>
      window.addEventListener(event, eventListenerCallback)
    );
  }

  // on logout, remove event listeners for logout countdown and clear current timeout
  if (!token) {
    clearTimeout(currentTimeout);
    events.forEach(event =>
      window.removeEventListener(event, eventListenerCallback)
    );
  }

  // return eventListenerCallback & timeouts to save to React State
  return {
    eventListenerCallback,
    timeouts
  };
};

export default initiateInactivityTimer;
